/**
 * 简介黑色主题颜色值
 */

/* 字体颜色 */
const color_header_primary = '#FFF';
const color_header_secondary = 'rgba(255, 255, 255, 0.45)';
const color_tools_regular = 'rgba(255, 255, 255, 0.65)';
const color_chat_name = 'rgba(255, 255, 255, 0.45)';
const color_chat_primary = '#FFF';
const color_send_color = 'rgba(255, 255, 255, 0.25)';
const color_send_font_color = '#666';
const color_text_active = '#FB2626';
const color_subscribe_text = '#E6E6E6';

/* 背景颜色 */
const background_color_primary = '#1a1a1a';
const background_color_default = '#000';
const background_header_color = 'transparent'; //顶部背景
const background_tools_color = '#262626'; //互动工具背景
const background_tabs_color = '#262626'; //聊天+tabs背景
const background_chat_color = 'rgba(255, 255, 255, 0.08)'; //聊天文案背景
const background_send_color = 'rgba(255, 255, 255, 0.06)'; //发送输入框文案背景
const background_subscribe_text = '#262626'; //预约页背景

const background_color_active = '#FB2626';
// 边框颜色
const border_tabs_color = '#1a1a1a'; //tabs下边框

export default {
  '--color_pc_header_primary': color_header_primary,
  '--color_pc_header_secondary': color_header_secondary,
  '--color_pc_tools_regular': color_tools_regular,
  '--color_pc_chat_name': color_chat_name,
  '--color_pc_chat_primary': color_chat_primary,
  '--color_pc_send_color': color_send_color,
  '--color_pc_send_font_color': color_send_font_color,
  '--color_pc_text_active': color_text_active,
  '--color_pc_subscribe_text': color_subscribe_text,
  '--background_pc_color_default': background_color_default,
  '--background_pc_color_primary': background_color_primary,
  '--background_pc_header_color': background_header_color,
  '--background_pc_tools_color': background_tools_color,
  '--background_pc_tabs_color': background_tabs_color,
  '--background_pc_chat_color': background_chat_color,
  '--background_pc_send_color': background_send_color,
  '--background_pc_color_active': background_color_active,
  '--border_pc_tabs_color': border_tabs_color,
  '--background_pc_subscribe_text': background_subscribe_text
};
